import { GeneralModel } from "./general.model";

export class CustomerType extends  GeneralModel {  
}